import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Directory pages
export const UserListPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users/list')) as Promise<
      typeof import('@pages/settings/directory/users/list')
    >
);

export const UserCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users/create')) as Promise<
      typeof import('@pages/settings/directory/users/create')
    >
);

export const UserEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users/edit')) as Promise<
      typeof import('@pages/settings/directory/users/edit')
    >
);

export const UsMktListPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users-mkt/usermkt-list')) as Promise<
      typeof import('@pages/settings/directory/users-mkt/usermkt-list')
    >
);

export const UsMktCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users-mkt/usermkt-create')) as Promise<
      typeof import('@pages/settings/directory/users-mkt/usermkt-create')
    >
);

export const UsMktEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/users-mkt/usermkt-edit')) as Promise<
      typeof import('@pages/settings/directory/users-mkt/usermkt-edit')
    >
);

export const RoleListPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/roles/list')) as Promise<
      typeof import('@pages/settings/directory/roles/list')
    >
);

export const RoleCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/roles/create')) as Promise<
      typeof import('@pages/settings/directory/roles/create')
    >
);

export const RoleEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/roles/edit')) as Promise<
      typeof import('@pages/settings/directory/roles/edit')
    >
);

export const TeamListPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/teams/list')) as Promise<
      typeof import('@pages/settings/directory/teams/list')
    >
);

export const TeamCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/teams/create')) as Promise<
      typeof import('@pages/settings/directory/teams/create')
    >
);

export const TeamEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/teams/edit')) as Promise<
      typeof import('@pages/settings/directory/teams/edit')
    >
);

// Bank pages
export const BankListPage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/banks/list')) as Promise<
      typeof import('@pages/settings/directory/banks/list')
    >
);

export const BankCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/directory/banks/create')) as Promise<
      typeof import('@pages/settings/directory/banks/create')
    >
);

